export default __webpack_public_path__ + "static/superbetter-design-mobile-acca0573e059079d81657a5a338d1c76.webp";